export default __webpack_public_path__ + "static/media/radio.dfa62608.svg";